// Recovered compiled webpack factory 18720. Edit this function expression; run npm run build.
(t, e, a) => {
  a.d(e, { l: () => x, toast: () => h });
  var o = a(12115),
    r = a(47650);
  let n = Array(12).fill(0),
    s = (t) => {
      let { visible: e, className: a } = t;
      return o.createElement(
        "div",
        { className: ["sonner-loading-wrapper", a].filter(Boolean).join(" "), "data-visible": e },
        o.createElement(
          "div",
          { className: "sonner-spinner" },
          n.map((t, e) =>
            o.createElement("div", { className: "sonner-loading-bar", key: `spinner-bar-${e}` }),
          ),
        ),
      );
    },
    i = o.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        height: "20",
        width: "20",
      },
      o.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
        clipRule: "evenodd",
      }),
    ),
    l = o.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        height: "20",
        width: "20",
      },
      o.createElement("path", {
        fillRule: "evenodd",
        d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
        clipRule: "evenodd",
      }),
    ),
    d = o.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        height: "20",
        width: "20",
      },
      o.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
        clipRule: "evenodd",
      }),
    ),
    c = o.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        height: "20",
        width: "20",
      },
      o.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
        clipRule: "evenodd",
      }),
    ),
    u = o.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "12",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
      },
      o.createElement("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
      o.createElement("line", { x1: "6", y1: "6", x2: "18", y2: "18" }),
    ),
    f = 1;
  class m {
    constructor() {
      ((this.subscribe = (t) => (
        this.subscribers.push(t),
        () => {
          let e = this.subscribers.indexOf(t);
          this.subscribers.splice(e, 1);
        }
      )),
        (this.publish = (t) => {
          this.subscribers.forEach((e) => e(t));
        }),
        (this.addToast = (t) => {
          (this.publish(t), (this.toasts = [...this.toasts, t]));
        }),
        (this.create = (t) => {
          var e;
          let { message: a, ...o } = t,
            r =
              "number" == typeof (null == t ? void 0 : t.id) ||
              (null == (e = t.id) ? void 0 : e.length) > 0
                ? t.id
                : f++,
            n = this.toasts.find((t) => t.id === r),
            s = void 0 === t.dismissible || t.dismissible;
          return (
            this.dismissedToasts.has(r) && this.dismissedToasts.delete(r),
            n
              ? (this.toasts = this.toasts.map((e) =>
                  e.id === r
                    ? (this.publish({ ...e, ...t, id: r, title: a }),
                      { ...e, ...t, id: r, dismissible: s, title: a })
                    : e,
                ))
              : this.addToast({ title: a, ...o, dismissible: s, id: r }),
            r
          );
        }),
        (this.dismiss = (t) => (
          t
            ? (this.dismissedToasts.add(t),
              requestAnimationFrame(() =>
                this.subscribers.forEach((e) => e({ id: t, dismiss: !0 })),
              ))
            : this.toasts.forEach((t) => {
                this.subscribers.forEach((e) => e({ id: t.id, dismiss: !0 }));
              }),
          t
        )),
        (this.message = (t, e) => this.create({ ...e, message: t })),
        (this.error = (t, e) => this.create({ ...e, message: t, type: "error" })),
        (this.success = (t, e) => this.create({ ...e, type: "success", message: t })),
        (this.info = (t, e) => this.create({ ...e, type: "info", message: t })),
        (this.warning = (t, e) => this.create({ ...e, type: "warning", message: t })),
        (this.loading = (t, e) => this.create({ ...e, type: "loading", message: t })),
        (this.promise = (t, e) => {
          let a, r;
          if (!e) return;
          void 0 !== e.loading &&
            (r = this.create({
              ...e,
              promise: t,
              type: "loading",
              message: e.loading,
              description: "function" != typeof e.description ? e.description : void 0,
            }));
          let n = Promise.resolve(t instanceof Function ? t() : t),
            s = void 0 !== r,
            i = n
              .then(async (t) => {
                if (((a = ["resolve", t]), o.isValidElement(t)))
                  ((s = !1), this.create({ id: r, type: "default", message: t }));
                else if (g(t) && !t.ok) {
                  s = !1;
                  let a =
                      "function" == typeof e.error
                        ? await e.error(`HTTP error! status: ${t.status}`)
                        : e.error,
                    n =
                      "function" == typeof e.description
                        ? await e.description(`HTTP error! status: ${t.status}`)
                        : e.description,
                    i = "object" != typeof a || o.isValidElement(a) ? { message: a } : a;
                  this.create({ id: r, type: "error", description: n, ...i });
                } else if (t instanceof Error) {
                  s = !1;
                  let a = "function" == typeof e.error ? await e.error(t) : e.error,
                    n = "function" == typeof e.description ? await e.description(t) : e.description,
                    i = "object" != typeof a || o.isValidElement(a) ? { message: a } : a;
                  this.create({ id: r, type: "error", description: n, ...i });
                } else if (void 0 !== e.success) {
                  s = !1;
                  let a = "function" == typeof e.success ? await e.success(t) : e.success,
                    n = "function" == typeof e.description ? await e.description(t) : e.description,
                    i = "object" != typeof a || o.isValidElement(a) ? { message: a } : a;
                  this.create({ id: r, type: "success", description: n, ...i });
                }
              })
              .catch(async (t) => {
                if (((a = ["reject", t]), void 0 !== e.error)) {
                  s = !1;
                  let a = "function" == typeof e.error ? await e.error(t) : e.error,
                    n = "function" == typeof e.description ? await e.description(t) : e.description,
                    i = "object" != typeof a || o.isValidElement(a) ? { message: a } : a;
                  this.create({ id: r, type: "error", description: n, ...i });
                }
              })
              .finally(() => {
                (s && (this.dismiss(r), (r = void 0)), null == e.finally || e.finally.call(e));
              }),
            l = () =>
              new Promise((t, e) => i.then(() => ("reject" === a[0] ? e(a[1]) : t(a[1]))).catch(e));
          return "string" != typeof r && "number" != typeof r
            ? { unwrap: l }
            : Object.assign(r, { unwrap: l });
        }),
        (this.custom = (t, e) => {
          let a = (null == e ? void 0 : e.id) || f++;
          return (this.create({ jsx: t(a), id: a, ...e }), a);
        }),
        (this.getActiveToasts = () => this.toasts.filter((t) => !this.dismissedToasts.has(t.id))),
        (this.subscribers = []),
        (this.toasts = []),
        (this.dismissedToasts = new Set()));
    }
  }
  let p = new m(),
    g = (t) =>
      t &&
      "object" == typeof t &&
      "ok" in t &&
      "boolean" == typeof t.ok &&
      "status" in t &&
      "number" == typeof t.status,
    h = Object.assign(
      (t, e) => {
        let a = (null == e ? void 0 : e.id) || f++;
        return (p.addToast({ title: t, ...e, id: a }), a);
      },
      {
        success: p.success,
        info: p.info,
        warning: p.warning,
        error: p.error,
        custom: p.custom,
        message: p.message,
        promise: p.promise,
        dismiss: p.dismiss,
        loading: p.loading,
      },
      { getHistory: () => p.toasts, getToasts: () => p.getActiveToasts() },
    );
  function b(t) {
    return void 0 !== t.label;
  }
  function v() {
    for (var t = arguments.length, e = Array(t), a = 0; a < t; a++) e[a] = arguments[a];
    return e.filter(Boolean).join(" ");
  }
  !(function (t) {
    if (!t || "undefined" == typeof document) return;
    let e = document.head || document.getElementsByTagName("head")[0],
      a = document.createElement("style");
    ((a.type = "text/css"),
      e.appendChild(a),
      a.styleSheet ? (a.styleSheet.cssText = t) : a.appendChild(document.createTextNode(t)));
  })(
    "[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999;transition:transform .4s ease}@media (hover:none) and (pointer:coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);background:var(--normal-bg);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]::before{content:'';position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]::before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]::before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]::before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]::after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]::before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y,0)) translateX(var(--swipe-amount-x,0));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 87%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 93%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 84%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg:#000;--normal-bg-hover:hsl(0, 0%, 12%);--normal-border:hsl(0, 0%, 20%);--normal-border-hover:hsl(0, 0%, 25%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 43%, 17%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 9%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}",
  );
  let y = (t) => {
    var e, a, r, n, f, m, p, g, h, y, w;
    let {
        invert: x,
        toast: E,
        unstyled: k,
        interacting: N,
        setHeights: M,
        visibleToasts: T,
        heights: S,
        index: B,
        toasts: C,
        expanded: z,
        removeToast: j,
        defaultRichColors: D,
        closeButton: I,
        style: R,
        cancelButtonStyle: Y,
        actionButtonStyle: $,
        className: A = "",
        descriptionClassName: P = "",
        duration: L,
        position: H,
        gap: V,
        expandByDefault: X,
        classNames: _,
        icons: U,
        closeButtonAriaLabel: F = "Close toast",
      } = t,
      [O, K] = o.useState(null),
      [q, W] = o.useState(null),
      [G, J] = o.useState(!1),
      [Q, Z] = o.useState(!1),
      [tt, te] = o.useState(!1),
      [ta, to] = o.useState(!1),
      [tr, tn] = o.useState(!1),
      [ts, ti] = o.useState(0),
      [tl, td] = o.useState(0),
      tc = o.useRef(E.duration || L || 4e3),
      tu = o.useRef(null),
      tf = o.useRef(null),
      tm = 0 === B,
      tp = B + 1 <= T,
      tg = E.type,
      th = !1 !== E.dismissible,
      tb = E.className || "",
      tv = E.descriptionClassName || "",
      ty = o.useMemo(() => S.findIndex((t) => t.toastId === E.id) || 0, [S, E.id]),
      tw = o.useMemo(() => {
        var t;
        return null != (t = E.closeButton) ? t : I;
      }, [E.closeButton, I]),
      tx = o.useMemo(() => E.duration || L || 4e3, [E.duration, L]),
      tE = o.useRef(0),
      tk = o.useRef(0),
      tN = o.useRef(0),
      tM = o.useRef(null),
      [tT, tS] = H.split("-"),
      tB = o.useMemo(() => S.reduce((t, e, a) => (a >= ty ? t : t + e.height), 0), [S, ty]),
      tC = (() => {
        let [t, e] = o.useState(document.hidden);
        return (
          o.useEffect(() => {
            let t = () => {
              e(document.hidden);
            };
            return (
              document.addEventListener("visibilitychange", t),
              () => window.removeEventListener("visibilitychange", t)
            );
          }, []),
          t
        );
      })(),
      tz = E.invert || x,
      tj = "loading" === tg;
    ((tk.current = o.useMemo(() => ty * V + tB, [ty, tB])),
      o.useEffect(() => {
        tc.current = tx;
      }, [tx]),
      o.useEffect(() => {
        J(!0);
      }, []),
      o.useEffect(() => {
        let t = tf.current;
        if (t) {
          let e = t.getBoundingClientRect().height;
          return (
            td(e),
            M((t) => [{ toastId: E.id, height: e, position: E.position }, ...t]),
            () => M((t) => t.filter((t) => t.toastId !== E.id))
          );
        }
      }, [M, E.id]),
      o.useLayoutEffect(() => {
        if (!G) return;
        let t = tf.current,
          e = t.style.height;
        t.style.height = "auto";
        let a = t.getBoundingClientRect().height;
        ((t.style.height = e),
          td(a),
          M((t) =>
            t.find((t) => t.toastId === E.id)
              ? t.map((t) => (t.toastId === E.id ? { ...t, height: a } : t))
              : [{ toastId: E.id, height: a, position: E.position }, ...t],
          ));
      }, [G, E.title, E.description, M, E.id, E.jsx, E.action, E.cancel]));
    let tD = o.useCallback(() => {
      (Z(!0),
        ti(tk.current),
        M((t) => t.filter((t) => t.toastId !== E.id)),
        setTimeout(() => {
          j(E);
        }, 200));
    }, [E, j, M, tk]);
    (o.useEffect(() => {
      let t;
      if ((!E.promise || "loading" !== tg) && E.duration !== 1 / 0 && "loading" !== E.type)
        return (
          z || N || tC
            ? (() => {
                if (tN.current < tE.current) {
                  let t = new Date().getTime() - tE.current;
                  tc.current = tc.current - t;
                }
                tN.current = new Date().getTime();
              })()
            : tc.current !== 1 / 0 &&
              ((tE.current = new Date().getTime()),
              (t = setTimeout(() => {
                (null == E.onAutoClose || E.onAutoClose.call(E, E), tD());
              }, tc.current))),
          () => clearTimeout(t)
        );
    }, [z, N, E, tg, tC, tD]),
      o.useEffect(() => {
        E.delete && (tD(), null == E.onDismiss || E.onDismiss.call(E, E));
      }, [tD, E.delete]));
    let tI =
      E.icon ||
      (null == U ? void 0 : U[tg]) ||
      ((t) => {
        switch (t) {
          case "success":
            return i;
          case "info":
            return d;
          case "warning":
            return l;
          case "error":
            return c;
          default:
            return null;
        }
      })(tg);
    return o.createElement(
      "li",
      {
        tabIndex: 0,
        ref: tf,
        className: v(
          A,
          tb,
          null == _ ? void 0 : _.toast,
          null == E || null == (e = E.classNames) ? void 0 : e.toast,
          null == _ ? void 0 : _.default,
          null == _ ? void 0 : _[tg],
          null == E || null == (a = E.classNames) ? void 0 : a[tg],
        ),
        "data-sonner-toast": "",
        "data-rich-colors": null != (y = E.richColors) ? y : D,
        "data-styled": !(E.jsx || E.unstyled || k),
        "data-mounted": G,
        "data-promise": !!E.promise,
        "data-swiped": tr,
        "data-removed": Q,
        "data-visible": tp,
        "data-y-position": tT,
        "data-x-position": tS,
        "data-index": B,
        "data-front": tm,
        "data-swiping": tt,
        "data-dismissible": th,
        "data-type": tg,
        "data-invert": tz,
        "data-swipe-out": ta,
        "data-swipe-direction": q,
        "data-expanded": !!(z || (X && G)),
        "data-testid": E.testId,
        style: {
          "--index": B,
          "--toasts-before": B,
          "--z-index": C.length - B,
          "--offset": `${Q ? ts : tk.current}px`,
          "--initial-height": X ? "auto" : `${tl}px`,
          ...R,
          ...E.style,
        },
        onDragEnd: () => {
          (te(!1), K(null), (tM.current = null));
        },
        onPointerDown: (t) => {
          2 !== t.button &&
            !tj &&
            th &&
            ((tu.current = new Date()),
            ti(tk.current),
            t.target.setPointerCapture(t.pointerId),
            "BUTTON" !== t.target.tagName &&
              (te(!0), (tM.current = { x: t.clientX, y: t.clientY })));
        },
        onPointerUp: () => {
          var t, e, a, o, r;
          if (ta || !th) return;
          tM.current = null;
          let n = Number(
              (null == (t = tf.current)
                ? void 0
                : t.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0,
            ),
            s = Number(
              (null == (e = tf.current)
                ? void 0
                : e.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0,
            ),
            i = new Date().getTime() - (null == (a = tu.current) ? void 0 : a.getTime()),
            l = "x" === O ? n : s,
            d = Math.abs(l) / i;
          if (Math.abs(l) >= 45 || d > 0.11) {
            (ti(tk.current),
              null == E.onDismiss || E.onDismiss.call(E, E),
              "x" === O ? W(n > 0 ? "right" : "left") : W(s > 0 ? "down" : "up"),
              tD(),
              to(!0));
            return;
          }
          (null == (o = tf.current) || o.style.setProperty("--swipe-amount-x", "0px"),
            null == (r = tf.current) || r.style.setProperty("--swipe-amount-y", "0px"),
            tn(!1),
            te(!1),
            K(null));
        },
        onPointerMove: (e) => {
          var a, o, r, n;
          if (
            !tM.current ||
            !th ||
            (null == (a = window.getSelection()) ? void 0 : a.toString().length) > 0
          )
            return;
          let s = e.clientY - tM.current.y,
            i = e.clientX - tM.current.x,
            l =
              null != (n = t.swipeDirections)
                ? n
                : (function (t) {
                    let [e, a] = t.split("-"),
                      o = [];
                    return (e && o.push(e), a && o.push(a), o);
                  })(H);
          !O && (Math.abs(i) > 1 || Math.abs(s) > 1) && K(Math.abs(i) > Math.abs(s) ? "x" : "y");
          let d = { x: 0, y: 0 },
            c = (t) => 1 / (1.5 + Math.abs(t) / 20);
          if ("y" === O) {
            if (l.includes("top") || l.includes("bottom"))
              if ((l.includes("top") && s < 0) || (l.includes("bottom") && s > 0)) d.y = s;
              else {
                let t = s * c(s);
                d.y = Math.abs(t) < Math.abs(s) ? t : s;
              }
          } else if ("x" === O && (l.includes("left") || l.includes("right")))
            if ((l.includes("left") && i < 0) || (l.includes("right") && i > 0)) d.x = i;
            else {
              let t = i * c(i);
              d.x = Math.abs(t) < Math.abs(i) ? t : i;
            }
          ((Math.abs(d.x) > 0 || Math.abs(d.y) > 0) && tn(!0),
            null == (o = tf.current) || o.style.setProperty("--swipe-amount-x", `${d.x}px`),
            null == (r = tf.current) || r.style.setProperty("--swipe-amount-y", `${d.y}px`));
        },
      },
      tw && !E.jsx && "loading" !== tg
        ? o.createElement(
            "button",
            {
              "aria-label": F,
              "data-disabled": tj,
              "data-close-button": !0,
              onClick:
                tj || !th
                  ? () => {}
                  : () => {
                      (tD(), null == E.onDismiss || E.onDismiss.call(E, E));
                    },
              className: v(
                null == _ ? void 0 : _.closeButton,
                null == E || null == (r = E.classNames) ? void 0 : r.closeButton,
              ),
            },
            null != (w = null == U ? void 0 : U.close) ? w : u,
          )
        : null,
      (tg || E.icon || E.promise) &&
        null !== E.icon &&
        ((null == U ? void 0 : U[tg]) !== null || E.icon)
        ? o.createElement(
            "div",
            {
              "data-icon": "",
              className: v(
                null == _ ? void 0 : _.icon,
                null == E || null == (n = E.classNames) ? void 0 : n.icon,
              ),
            },
            E.promise || ("loading" === E.type && !E.icon)
              ? E.icon ||
                  (function () {
                    var t, e;
                    return (null == U ? void 0 : U.loading)
                      ? o.createElement(
                          "div",
                          {
                            className: v(
                              null == _ ? void 0 : _.loader,
                              null == E || null == (e = E.classNames) ? void 0 : e.loader,
                              "sonner-loader",
                            ),
                            "data-visible": "loading" === tg,
                          },
                          U.loading,
                        )
                      : o.createElement(s, {
                          className: v(
                            null == _ ? void 0 : _.loader,
                            null == E || null == (t = E.classNames) ? void 0 : t.loader,
                          ),
                          visible: "loading" === tg,
                        });
                  })()
              : null,
            "loading" !== E.type ? tI : null,
          )
        : null,
      o.createElement(
        "div",
        {
          "data-content": "",
          className: v(
            null == _ ? void 0 : _.content,
            null == E || null == (f = E.classNames) ? void 0 : f.content,
          ),
        },
        o.createElement(
          "div",
          {
            "data-title": "",
            className: v(
              null == _ ? void 0 : _.title,
              null == E || null == (m = E.classNames) ? void 0 : m.title,
            ),
          },
          E.jsx ? E.jsx : "function" == typeof E.title ? E.title() : E.title,
        ),
        E.description
          ? o.createElement(
              "div",
              {
                "data-description": "",
                className: v(
                  P,
                  tv,
                  null == _ ? void 0 : _.description,
                  null == E || null == (p = E.classNames) ? void 0 : p.description,
                ),
              },
              "function" == typeof E.description ? E.description() : E.description,
            )
          : null,
      ),
      o.isValidElement(E.cancel)
        ? E.cancel
        : E.cancel && b(E.cancel)
          ? o.createElement(
              "button",
              {
                "data-button": !0,
                "data-cancel": !0,
                style: E.cancelButtonStyle || Y,
                onClick: (t) => {
                  b(E.cancel) &&
                    th &&
                    (null == E.cancel.onClick || E.cancel.onClick.call(E.cancel, t), tD());
                },
                className: v(
                  null == _ ? void 0 : _.cancelButton,
                  null == E || null == (g = E.classNames) ? void 0 : g.cancelButton,
                ),
              },
              E.cancel.label,
            )
          : null,
      o.isValidElement(E.action)
        ? E.action
        : E.action && b(E.action)
          ? o.createElement(
              "button",
              {
                "data-button": !0,
                "data-action": !0,
                style: E.actionButtonStyle || $,
                onClick: (t) => {
                  b(E.action) &&
                    (null == E.action.onClick || E.action.onClick.call(E.action, t),
                    t.defaultPrevented || tD());
                },
                className: v(
                  null == _ ? void 0 : _.actionButton,
                  null == E || null == (h = E.classNames) ? void 0 : h.actionButton,
                ),
              },
              E.action.label,
            )
          : null,
    );
  };
  function w() {
    if ("undefined" == typeof window || "undefined" == typeof document) return "ltr";
    let t = document.documentElement.getAttribute("dir");
    return "auto" !== t && t ? t : window.getComputedStyle(document.documentElement).direction;
  }
  let x = o.forwardRef(function (t, e) {
    let {
        id: a,
        invert: n,
        position: s = "bottom-right",
        hotkey: i = ["altKey", "KeyT"],
        expand: l,
        closeButton: d,
        className: c,
        offset: u,
        mobileOffset: f,
        theme: m = "light",
        richColors: g,
        duration: h,
        style: b,
        visibleToasts: v = 3,
        toastOptions: x,
        dir: E = w(),
        gap: k = 14,
        icons: N,
        containerAriaLabel: M = "Notifications",
      } = t,
      [T, S] = o.useState([]),
      B = o.useMemo(
        () => (a ? T.filter((t) => t.toasterId === a) : T.filter((t) => !t.toasterId)),
        [T, a],
      ),
      C = o.useMemo(
        () => Array.from(new Set([s].concat(B.filter((t) => t.position).map((t) => t.position)))),
        [B, s],
      ),
      [z, j] = o.useState([]),
      [D, I] = o.useState(!1),
      [R, Y] = o.useState(!1),
      [$, A] = o.useState(
        "system" !== m
          ? m
          : "undefined" != typeof window &&
              window.matchMedia &&
              window.matchMedia("(prefers-color-scheme: dark)").matches
            ? "dark"
            : "light",
      ),
      P = o.useRef(null),
      L = i.join("+").replace(/Key/g, "").replace(/Digit/g, ""),
      H = o.useRef(null),
      V = o.useRef(!1),
      X = o.useCallback((t) => {
        S((e) => {
          var a;
          return (
            (null == (a = e.find((e) => e.id === t.id)) ? void 0 : a.delete) || p.dismiss(t.id),
            e.filter((e) => {
              let { id: a } = e;
              return a !== t.id;
            })
          );
        });
      }, []);
    return (
      o.useEffect(
        () =>
          p.subscribe((t) => {
            if (t.dismiss)
              return void requestAnimationFrame(() => {
                S((e) => e.map((e) => (e.id === t.id ? { ...e, delete: !0 } : e)));
              });
            setTimeout(() => {
              r.flushSync(() => {
                S((e) => {
                  let a = e.findIndex((e) => e.id === t.id);
                  return -1 !== a
                    ? [...e.slice(0, a), { ...e[a], ...t }, ...e.slice(a + 1)]
                    : [t, ...e];
                });
              });
            });
          }),
        [T],
      ),
      o.useEffect(() => {
        if ("system" !== m) return void A(m);
        if (
          ("system" === m &&
            (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
              ? A("dark")
              : A("light")),
          "undefined" == typeof window)
        )
          return;
        let t = window.matchMedia("(prefers-color-scheme: dark)");
        try {
          t.addEventListener("change", (t) => {
            let { matches: e } = t;
            e ? A("dark") : A("light");
          });
        } catch (e) {
          t.addListener((t) => {
            let { matches: e } = t;
            try {
              e ? A("dark") : A("light");
            } catch (t) {
              console.error(t);
            }
          });
        }
      }, [m]),
      o.useEffect(() => {
        T.length <= 1 && I(!1);
      }, [T]),
      o.useEffect(() => {
        let t = (t) => {
          var e, a;
          (i.every((e) => t[e] || t.code === e) && (I(!0), null == (a = P.current) || a.focus()),
            "Escape" === t.code &&
              (document.activeElement === P.current ||
                (null == (e = P.current) ? void 0 : e.contains(document.activeElement))) &&
              I(!1));
        };
        return (
          document.addEventListener("keydown", t),
          () => document.removeEventListener("keydown", t)
        );
      }, [i]),
      o.useEffect(() => {
        if (P.current)
          return () => {
            H.current &&
              (H.current.focus({ preventScroll: !0 }), (H.current = null), (V.current = !1));
          };
      }, [P.current]),
      o.createElement(
        "section",
        {
          ref: e,
          "aria-label": `${M} ${L}`,
          tabIndex: -1,
          "aria-live": "polite",
          "aria-relevant": "additions text",
          "aria-atomic": "false",
          suppressHydrationWarning: !0,
        },
        C.map((e, a) => {
          var r;
          let [s, i] = e.split("-");
          return B.length
            ? o.createElement(
                "ol",
                {
                  key: e,
                  dir: "auto" === E ? w() : E,
                  tabIndex: -1,
                  ref: P,
                  className: c,
                  "data-sonner-toaster": !0,
                  "data-sonner-theme": $,
                  "data-y-position": s,
                  "data-x-position": i,
                  style: {
                    "--front-toast-height": `${(null == (r = z[0]) ? void 0 : r.height) || 0}px`,
                    "--width": "356px",
                    "--gap": `${k}px`,
                    ...b,
                    ...(function (t, e) {
                      let a = {};
                      return (
                        [t, e].forEach((t, e) => {
                          let o = 1 === e,
                            r = o ? "--mobile-offset" : "--offset",
                            n = o ? "16px" : "24px";
                          function s(t) {
                            ["top", "right", "bottom", "left"].forEach((e) => {
                              a[`${r}-${e}`] = "number" == typeof t ? `${t}px` : t;
                            });
                          }
                          "number" == typeof t || "string" == typeof t
                            ? s(t)
                            : "object" == typeof t
                              ? ["top", "right", "bottom", "left"].forEach((e) => {
                                  void 0 === t[e]
                                    ? (a[`${r}-${e}`] = n)
                                    : (a[`${r}-${e}`] =
                                        "number" == typeof t[e] ? `${t[e]}px` : t[e]);
                                })
                              : s(n);
                        }),
                        a
                      );
                    })(u, f),
                  },
                  onBlur: (t) => {
                    V.current &&
                      !t.currentTarget.contains(t.relatedTarget) &&
                      ((V.current = !1),
                      H.current && (H.current.focus({ preventScroll: !0 }), (H.current = null)));
                  },
                  onFocus: (t) => {
                    !(
                      t.target instanceof HTMLElement && "false" === t.target.dataset.dismissible
                    ) &&
                      (V.current || ((V.current = !0), (H.current = t.relatedTarget)));
                  },
                  onMouseEnter: () => I(!0),
                  onMouseMove: () => I(!0),
                  onMouseLeave: () => {
                    R || I(!1);
                  },
                  onDragEnd: () => I(!1),
                  onPointerDown: (t) => {
                    (t.target instanceof HTMLElement && "false" === t.target.dataset.dismissible) ||
                      Y(!0);
                  },
                  onPointerUp: () => Y(!1),
                },
                B.filter((t) => (!t.position && 0 === a) || t.position === e).map((a, r) => {
                  var s, i;
                  return o.createElement(y, {
                    key: a.id,
                    icons: N,
                    index: r,
                    toast: a,
                    defaultRichColors: g,
                    duration: null != (s = null == x ? void 0 : x.duration) ? s : h,
                    className: null == x ? void 0 : x.className,
                    descriptionClassName: null == x ? void 0 : x.descriptionClassName,
                    invert: n,
                    visibleToasts: v,
                    closeButton: null != (i = null == x ? void 0 : x.closeButton) ? i : d,
                    interacting: R,
                    position: e,
                    style: null == x ? void 0 : x.style,
                    unstyled: null == x ? void 0 : x.unstyled,
                    classNames: null == x ? void 0 : x.classNames,
                    cancelButtonStyle: null == x ? void 0 : x.cancelButtonStyle,
                    actionButtonStyle: null == x ? void 0 : x.actionButtonStyle,
                    closeButtonAriaLabel: null == x ? void 0 : x.closeButtonAriaLabel,
                    removeToast: X,
                    toasts: B.filter((t) => t.position == a.position),
                    heights: z.filter((t) => t.position == a.position),
                    setHeights: j,
                    expandByDefault: l,
                    gap: k,
                    expanded: D,
                    swipeDirections: t.swipeDirections,
                  });
                }),
              )
            : null;
        }),
      )
    );
  });
}
